import baseURLGlobal from '../../utils/util';
export const IMAGE_BASE_URL = 'https://cdn-cp-assets-public.classplus.co/classplus-websites/common/images/may21/';

// FOR ANY CHANGES IN TARGET, JUST CHANGE THE VALUE OF BELOW
export const base_Url = baseURLGlobal;
export const GET = 'GET';
export const POST = 'POST';

// FUNCTION TO CAPTURE QUERY PARAMETERS, initialized by '?', separated by '&'
export const getQuery = () => {
	let b = window.location.search
		.slice(1)
		.split('&')
		.map((qStr) => qStr.split('='))
		.reduce((acc, inc) => {
			acc[inc[0]] = inc[1];
			return acc;
		}, {});
	return b;
};

const token = getQuery()['token'] || sessionStorage.getItem('scratchToken');

// API CALL FUNCTION
export const makeApiCal = (action) => {
	// PARAMETERS - method, route, storeData, catchError, body

	switch (action.method) {
		case GET:
			return fetch(`${base_Url}${action.route}`, {
				method: GET,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
			})
				.then((res) => res.json())
				.then((res) => {
					res?.status === 'success'
						? action.storeData(res?.data)
						: action.catchError(res.message);
				})
				.catch((err) => {
					action.catchError(err);
				});
		case POST:
			return fetch(`${base_Url}/${action.route}`, {
				method: POST,
				headers: {
					'x-access-token': token,
					'Content-Type': 'application/json',
					'Connection': 'keep-alive',
				},
				body: JSON.stringify(action.body),
			})
				.then((res) => res.json())
				.then((res) => {
					res?.status === 'success'
						? action.storeData(res?.data)
						: action.catchError(res.message);
				})
				.catch((err) => action.catchError(err));
	}
};
